export default function MobileMenu() {
	const mobileMenuToggles = document.querySelectorAll('.js-menu-toggle');

	if (!mobileMenuToggles) {
		return;
	}

	mobileMenuToggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const body = document.querySelector('body');
			const menu = document.querySelector('.resp-menu');

			if (menu.classList.contains('open')) {
				menu.classList.remove('open');
				menu.classList.add('closing');
				setTimeout(() => {
					menu.classList.remove('closing');
				}, 1000); // Remove the 'closing' class after the animation duration
			} else {
				menu.classList.add('open');
			}
			toggle.classList.toggle('menu-toggle--active');
			body.classList.toggle('menu-open');
		});
	});
}
